export default {
    state: {
        inicioGestion: null,
        infoContacto: null,
        datosGestion: {
            gestion: {
                tipo: null,
                subtipo: null,
                causal_mora_id: null,
                observacion: '',
                gestion_obligacion: [],
                origen: null
            },
            acuerdo_pago: {
                fecha_primer_pago: null,
                dia_pago: null,
                monto_congelar: null,
                valor_cuota_inicial: 0,
                cuotas: null,
                valor_cuota: null,
                valor_compromiso: 0
            },
            pqrs: {
                asunto: '',
                tipo_pqrs: null,
                correo_notificacion: null
            }
        }
    },
    getters: {
        inicioGestion: state => state.inicioGestion,
        infoContacto: state => state.infoContacto,
        datosGestion: state => state.datosGestion
    },
    mutations: {
        SET_INICIO_GESTION: (state, payload) => state.inicioGestion = payload,
        SET_INFO_CONTACTO: (state, payload) => state.infoContacto = payload,
        SET_DATOS_GESTION: (state, payload) => state.datosGestion[payload.obj][payload.key] = payload.value,
        SET_INIT_DATOS_GESTION: (state, payload) => state.datosGestion = payload
    },
    actions: {
        guardarGestion({
            commit
        }, payload) {
            return this.dispatch('store', {
                endpoint: 'gestion',
                params: payload
            })
        },
        refreshInfoContacto({
            commit
        }, payload) {
            commit('SET_INFO_CONTACTO', payload)
        },
        generarDocumento({
            commit,
            dispatch
        }, payload) {

            var tipo_reponse = '';

            if (payload.accion == 'descargar') {
                tipo_reponse = 'blob'
            } else {
                tipo_reponse = 'text'
            }

            return new Promise((res, rej) => {
                this.getters.api.post('/utilidades/generar-documento', payload, {
                        responseType: tipo_reponse,
                    })
                    .then((response) => {
                        res(response)
                    }).catch((error) => {
                        rej(error)
                    });
            });
        },
        enviarSMS({
            commit,
            dispatch
        }, payload) {
            return new Promise((res, rej) => {
                this.getters.api.post('/utilidades/enviar-sms', payload)
                    .then(response =>
                        res(response.data)
                    ).catch(error =>
                        rej(error)
                    )
            }).then(() => {

            });
        },
        enviarEmail({
            commit,
            dispatch
        }, payload) {
            return new Promise((res, rej) => {
                this.getters.api.post('/utilidades/enviar-email', payload)
                    .then(response =>
                        res(response.data)
                    ).catch(error =>
                        rej(error)
                    )
            }).then(() => {

            });
        },
        datosAbonoGestion({commit, dispatch}, payload) {
            return new Promise((res, rej) => {
                this.getters.api.get('/utilidades/acuerdo-gestion')
                .then(response => {
                    res(response.data)
                }).catch(error =>
                    rej(error)
                )
            })
        }
    }
}